import api from './api';

export const get = query =>
	api.get('/logistic/fre-divergence', { params: query });
